import axios, { AxiosResponse } from 'axios';

import APPCONSTANTS from '../constants/appConstants';
import ERRORS from '../constants/error';
import { fetchLoggedInUser, resetStore, sessionTimedout } from '../store/user/actions';
import toastCenter from '../utils/toastCenter';
import ApiError from './ApiError';

export const setupInterceptors = (store: any) => {
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
  axios.defaults.headers.post['Content-Type'] = 'application/json';
  axios.defaults.headers.client = 'web';
  axios.defaults.headers['country-code'] = 'all';
  axios.defaults.validateStatus = () => true;
  axios.defaults.withCredentials = true;
  const dhisUrl = 'cfr-service/report/send-to-dhis';

  axios.interceptors.response.use(
    (response: AxiosResponse) => {
      const {
        status,
        config: { url = '' },
        data: { message = '' }
      } = response;
      if (status > 205) {
        switch (status) {
          case 500:
          case 502:
            if (url === dhisUrl && message.includes('401')) {
              throw new ApiError(ERRORS.DHIS_NOT_AUTHENTICATED);
            }
            throw new ApiError(ERRORS.SERVER_ERROR);
          case 403:
            throw new ApiError(ERRORS.UNAUTHORIZED);
          case 401:
            store.dispatch(sessionTimedout(response.data.message || APPCONSTANTS.SESSION_EXPIRED));
            store.dispatch(resetStore());
            toastCenter.error(APPCONSTANTS.ERROR, APPCONSTANTS.SESSION_EXPIRED, { animateIfActive: false });
            throw new ApiError(ERRORS.NOT_AUTHENTICATED);
          case 409:
            throw new ApiError({
              ...response.data,
              message: response.data.entity?.conflicts?.[0]?.value || response.data.message
            });
          case 406:
            throw new ApiError(response.data);
          case 400:
            throw new ApiError(response.data);
          case 432:
            throw new ApiError(response.data);
          case 408:
            throw new ApiError(response.data);
          case 404:
            throw new ApiError(response.data);
          default:
            throw new ApiError(response);
        }
      } else {
        return response;
      }
    },
    () => {
      throw new ApiError(ERRORS.NETWORK_ERROR);
    }
  );

  // get logged in user while refresh
  store.dispatch(fetchLoggedInUser());
};
